import angular from 'angular';

import template from './tsz-contact.html';
import './tsz-contact.styl';

import contactTpl from './modals/contact.html';

function controller($mdDialog) {

  'ngInject';

  this.showContactForm = (ev) => {

    $mdDialog.show({
      controller: ($scope, AuthService, ContactService, $tszToast) => {

        $scope.message = {};

        const user = AuthService.getAuthenticatedUser();
        if (user) {
          $scope.message.name = user.name;
          $scope.message.phone = user.phone;
          $scope.message.email = user.email;
        }

        $scope.send = () => {
          this.loading = true;
          console.log(JSON.stringify($scope.message));
          ContactService.send($scope.message)
          .then(() => {
            $tszToast.showSuccess('Mensaje enviado');
            $mdDialog.hide();
          }).catch(() => {
            $tszToast.showError('Error al intentar enviar el mensaje');
          }).finally(() => {
            this.loading = false;
          });
        };

        $scope.close = () => {
          $mdDialog.hide();
        };

      },
      template: contactTpl,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

  this.showPrivacyPolicyDialog = (ev) => {
    $mdDialog.show({
      controller: ($scope) => {
        $scope.close = () => {
          $mdDialog.hide();
        };
      },
      controllerAs: 'ctrl',
      templateUrl: '/static/modals/privacy_policy.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

}

export default {
  template,
  bindings: {
    companyId: '<',
    label: '@',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-contact/tsz-contact.js